@if (display && withShell) {
<astral-field-shell
  [control]="control"
  [forId]="resolvedInputId"
  [helpText]="helpText"
  [label]="resolvedLabel"
  [readonly]="resolvedReadonly"
  [disabled]="resolvedDisabled"
  [required]="resolvedRequired"
  [errorMessage]="errorMessage"
  [invalid]="invalid"
>
  <ng-container [ngTemplateOutlet]="dateInputTemplate"></ng-container>
</astral-field-shell>
} @else if (display) {
  <ng-container [ngTemplateOutlet]="dateInputTemplate"></ng-container>
}

<ng-template #dateInputTemplate>
  <div
    class="astral-date-picker"
    [class.astral-date-picker--readonly]="resolvedReadonly"
    [class.astral-date-picker--disabled]="resolvedDisabled"
    [class.astral-date-picker--focused]="isFocused"
  >
    <div class="astral-date-picker__actions">
      @if (showClearOthers) {
        <astral-field-action
        icon="clearOthers"
        titleKey="COMMON.CLEAR_OTHER_FILTERS"
        ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
        (click)="clearAllOtherInputs()"
        ></astral-field-action>
      }

      @if (showClearThis) {
        <astral-field-action
        icon="clear"
        titleKey="COMMON.CLEAR"
        ariaLabelKey="COMMON.CLEAR"
        (click)="clearInput()"
        ></astral-field-action>
      }
    </div>

    <div class="astral-date-picker__control-shell" [class.astral-date-picker__control-shell--readonly]="resolvedReadonly">
      @if (resolvedReadonly) {
        <span class="astral-date-picker__readonly-icon" aria-hidden="true">
          <i [class]="readonlyIconClass"></i>
        </span>
      }

      <input
        #input
        astralFieldAccessibility
        [astralFieldControl]="rawControl"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        [astralFieldInvalid]="invalid"
        [astralFieldRequired]="resolvedRequired"
        class="astral-date-picker__control"
        type="text"
        inputmode="numeric"
        [placeholder]="datePlaceholder"
        autocomplete="off"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [value]="displayedInputValue"
        [readonly]="resolvedReadonly ? true : null"
        [disabled]="resolvedDisabled ? true : null"
        [required]="resolvedRequired ? true : null"
        (input)="handleTextInput($any($event.target).value)"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
      />

      @if (!resolvedReadonly && !resolvedDisabled) {
        <button
          type="button"
          class="astral-date-picker__calendar-button"
          title="Open date picker"
          aria-label="Open date picker"
          (click)="openCalendar()"
        >
          <i class="fa-light fa-calendar" aria-hidden="true"></i>
        </button>

        <input
          #calendarInput
          class="astral-date-picker__calendar-input"
          type="date"
          tabindex="-1"
          aria-hidden="true"
          [attr.max]="maxDate"
          [value]="inputValue"
          (change)="handleCalendarChange($any($event.target).value)"
        />
      }
    </div>
  </div>
</ng-template>
